import React, { useState } from 'react'
import { Stack, TextField, Button, Modal, useMediaQuery, Box, Typography } from '@mui/material'
import { useTheme } from '@mui/material/styles'

const AddContactModal = ({ open, handleAdd, handleClose, source }) => {
    const theme = useTheme()
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'))

    const [customer, setCustomer] = useState({
        username: '',
        full_name: '',
        email: '',
        extra_info: '',
        address: ''
    })

    const onClose = () => {
        if (handleClose) {
            handleClose()
        }
    }

    const onAdd = () => {
        if (handleAdd) {
            handleAdd(customer)
        }
    }

    return (
        <Modal
            open={open}
            onClose={onClose}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
        >
            <Box
                sx={{
                    position: 'absolute',
                    top: '50%',
                    left: '50%',
                    transform: 'translate(-50%, -50%)',
                    width: isMobile ? '90%' : 400,
                    bgcolor: 'background.paper',
                    border: '2px solid #000',
                    boxShadow: 24,
                    p: 4,
                    borderRadius: 2,
                }}
            >
                <Stack spacing={2}>
                    <Typography variant="h6" component="h4" textAlign="center">
                        Thêm tài khoản
                    </Typography>

                    <TextField
                        label="Số điện thoại"
                        variant="standard"
                        placeholder="Số điện thoại"
                        value={customer.username ?? ''}
                        onChange={(e) => setCustomer((old) => ({ ...old, username: e.target.value }))}
                    />

                    <TextField
                        label="Tên khách hàng"
                        variant="standard"
                        placeholder="Tên khách hàng"
                        value={customer.full_name ?? ''}
                        onChange={(e) => setCustomer((old) => ({ ...old, full_name: e.target.value }))}
                    />

                    <TextField
                        label="Email"
                        variant="standard"
                        placeholder="Email"
                        value={customer.email ?? ''}
                        onChange={(e) => setCustomer((old) => ({ ...old, email: e.target.value }))}
                    />

                    <TextField
                        label="Địa chỉ"
                        variant="standard"
                        placeholder="Địa chỉ"
                        value={customer.address ?? ''}
                        onChange={(e) => setCustomer((old) => ({ ...old, address: e.target.value }))}
                    />

                    <TextField
                        id="outlined-textarea"
                        variant="standard"
                        label="Ghi chú"
                        multiline
                        rows={4}
                        value={customer.extra_info ?? ''}
                        onChange={(e) => setCustomer((old) => ({ ...old, extra_info: e.target.value }))}
                    />

                    <Stack
                        flexDirection="row"
                        spacing={2}
                        style={{ marginTop: '24px' }}
                        sx={{alignItems: 'center'}}
                        justifyContent="center"
                        gap={2}
                    >
                        <Button
                            onClick={handleClose}
                            color="warning"
                            variant="outlined"
                            sx={{ flex: 1 }}
                        >
                            Huỷ
                        </Button>
                        <Button
                            disabled={customer.username.length !== 10 || customer.full_name.length === 0}
                            onClick={onAdd}
                            color="success"s
                            variant="contained"
                            sx={{ flex: 1, mt: '0px !important' }}
                        >
                            Thêm tài khoản
                        </Button>
                    </Stack>
                </Stack>
            </Box>
        </Modal>
    )
}

export default AddContactModal